<snelstart-ui-button (click)="this.showDialog()"
                     [disabled]="isPartner ? ((incomeTaxEntity$ | async)?.aangifte?.partnerAangifte?.box1?.winstUitOnderneming?.ondernemingen?.at(indexOnderneming)?.kortlopendeSchulden?.at(1)?.waardeSlot ?? null) === null :((incomeTaxEntity$ | async)?.aangifte?.box1?.winstUitOnderneming?.ondernemingen?.at(indexOnderneming)?.kortlopendeSchulden?.at(1)?.waardeSlot ?? null) === null"
                     class="custom-input-150"
                     icon="plus"
                     type="secondary">Specificeer
</snelstart-ui-button>

<snelstart-ui-dialog-definition [(visible)]="dialogVisible" id="lg" size="lg"
                                title="Specificatie te betalen omzetbelasting slotbalans">
  <snelstart-ui-dialog-header-content>
    Geef aan op welke jaren het bedrag van de eindbalans betrekking heeft.
  </snelstart-ui-dialog-header-content>
  <snelstart-ui-dialog-body>
    <form (change)="saveForm()" [formGroup]="formGroup">
      <snelstart-ui-number-form-control [decimals]="0"
                                        align="right"
                                        class="custom-input-250"
                                        formControlName="omzetbelastingDitBoekjaar"
                                        label="Dit boekjaar"
                                        prefix="€"
      >
      </snelstart-ui-number-form-control>
      <snelstart-ui-number-form-control [decimals]="0"
                                        align="right"
                                        class="custom-input-250"
                                        formControlName="omzetbelastingVorigBoekjaar"
                                        label="Vorig boekjaar"
                                        prefix="€"
      >
      </snelstart-ui-number-form-control>
      <snelstart-ui-number-form-control [decimals]="0"
                                        align="right"
                                        class="custom-input-250"
                                        formControlName="omzetbelastingOudereBoekjaren"
                                        label="Oudere boekjaren"
                                        prefix="€"
      >
      </snelstart-ui-number-form-control>
      @if (getTotaalSchuldSpec() !== formGroup.getRawValue().waardeSlot) {
        <snelstart-ui-alert class="mt-3" type="warning">
          Het totaal van de specificatie ad € {{getTotaalSchuldSpec()}} is niet gelijk
          aan het saldo op de eindbalans ad € {{formGroup.getRawValue().waardeSlot ?? 0}}.
        </snelstart-ui-alert>
      }
    </form>
  </snelstart-ui-dialog-body>
  <snelstart-ui-dialog-buttons class="d-flex">
    <snelstart-ui-button btn-x class="me-1" id="cancel" type="secondary">Annuleren</snelstart-ui-button>
    <snelstart-ui-button icon="check"
                         id="save"
                         [disabled]="getTotaalSchuldSpec() !== formGroup.getRawValue().waardeSlot"
                         type="primary">
      Opslaan
    </snelstart-ui-button>
  </snelstart-ui-dialog-buttons>
</snelstart-ui-dialog-definition>
